export const EVENT_AUTH = 'EVENT_AUTH';
export const EVENT_MEAL = 'EVENT_MEAL';
